export const retrieveLGAsService = async (state: string) => {
    try {
        const response = await fetch(`https://nga-states-lga.onrender.com/?state=${state}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res.map((state: string, index: string) => ({ id: index, title: state }));
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
